export default  {
  inject: ["showExpand"],
  props: {
    countHeaders: {
      type: Number,
      required: true
    }
  },
  computed: {
    colspan() {
      return this.countHeaders + (this.showSelect ? 1 : 0) + (this.showExpand ? 1 : 0)
    }
  }
}
